import React from 'react';
import SSRIcon from '@ingka/ssr-icon';
import ascIcon from '@ingka/ssr-icon/paths/sort-ascending';
import descIcon from '@ingka/ssr-icon/paths/sort-descending';
import styled from '@emotion/styled';
import { theme } from '../../../../shared/styles/core/theme';
import { tokens } from '../../../../shared/styles/core/tokens';

type SortLabelProps = {
   isSortedDesc?: boolean;
};

export const SortLabel = ({ isSortedDesc }: SortLabelProps) => {
   return (
      <StyledWrapperDiv $hasIcon={isSortedDesc !== undefined}>
         {isSortedDesc !== undefined && <StyledSSRIcon paths={isSortedDesc ? ascIcon : descIcon} />}
      </StyledWrapperDiv>
   );
};

const StyledWrapperDiv = styled.div<{ $hasIcon: boolean }>`
   width: ${({ $hasIcon }) => $hasIcon ? '24px' : '0'};
   height: 24px;
   padding-left: ${({ $hasIcon }) => $hasIcon ? tokens.space.xs : '0'};
`;

const StyledSSRIcon = styled(SSRIcon)`
   color: ${theme.colors.text.tertiary};

   :hover {
      color: ${theme.colors.text.primary};
   }
`;
